import {NgModule}                                                        from '@angular/core';
import {InfoLegalComponent}                                              from './components/info-legal.component';
import {InfoImprintComponent}                                            from './components/info-imprint.component';
import {InfoAgreementComponent}                                          from './components/info-agreement.component';
import {FormsModule, ReactiveFormsModule}                                from '@angular/forms';
import {CommonModule}                                                    from '@angular/common';
import {ApCoreModule}                                                    from '../ap-core/ap-core.module';
import {ApIconModule}                                                    from '../icons/ap-icon.module';
import {LayoutModule}                                                    from '@progress/kendo-angular-layout';
import {ApStatisticsModule}                                              from '../statistics/ap-statistics.module';
import {ButtonModule, SplitButtonModule}                                 from '@progress/kendo-angular-buttons';
import {ApLayoutModule}                                                  from '../layout/ap-layout.module';
import {InputsModule}                                                    from '@progress/kendo-angular-inputs';
import {ComboBoxModule, DropDownsModule}                                 from '@progress/kendo-angular-dropdowns';
import {DateInputsModule}                                                from '@progress/kendo-angular-dateinputs';
import {BodyModule, GridModule, HeaderModule, PagerModule, SharedModule} from '@progress/kendo-angular-grid';
import {ApTranslationModule}                                             from '../translation/ap-translation.module';
import {ApUtilsModule}                                                   from '../ap-utils';
import {ApSectionHeaderModule}                                           from '../ap-section-header/ap-section-header.module';
import {ApResponsiveTextModule}                                          from '../ap-responsive-text/ap-responsive-text.module';
import {ApDynComponentModule}                                            from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApInfoRoutes}                                                    from './ap-info.routes';
import {InfoContactComponent}                                            from './components/info-contact.component';
import {ApPdfViewerModule}                                               from '../ap-pdf-viewer/ap-pdf-viewer.module';
import {InfoVersionComponent}                                            from './components/info-version.component';
import {LoaderModule}                                                    from '@progress/kendo-angular-indicators';

@NgModule({
  declarations: [
    InfoAgreementComponent,
    InfoContactComponent,
    InfoImprintComponent,
    InfoLegalComponent,
    InfoVersionComponent
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ApCoreModule,
    ApIconModule,
    LayoutModule,
    ApStatisticsModule,
    ButtonModule,
    ApLayoutModule,
    SplitButtonModule,
    InputsModule,
    ComboBoxModule,
    DateInputsModule,
    DropDownsModule,
    FormsModule,
    GridModule,
    ApTranslationModule,
    ApInfoRoutes,
    SharedModule,
    BodyModule,
    ApUtilsModule,
    PagerModule,
    HeaderModule,
    ApSectionHeaderModule,
    ApResponsiveTextModule,
    ApDynComponentModule,
    ApPdfViewerModule,
    LoaderModule,
  ],
  exports: [
    InfoAgreementComponent,
    InfoContactComponent,
    InfoImprintComponent,
    InfoLegalComponent,
    InfoVersionComponent
  ],
  providers: []
})
export class ApInfoModule {
}
